module.exports = __webpack_public_path__ + "img/all-list.196af28d.svg";